<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :title="title"
      inline-message
      :width="'1300px'"
    >
      <div class="details-view">
        <div class="commerce_content">
          <div class="section" style="margin-bottom: 10px">
            <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
            <div style="margin-top: 5px">
              <el-form :disabled="!isEdit" inline label-width="80px" label-position="top" width="100%">
                <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')" :required="true">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Region"
                    filterable
                    :default-value="commerceForm.code"
                    filter-type="global"
                    :filter-tag-names="['code', 'name', 'nameEnglish']"
                    :tag-name="'code'"
                    style="width:385px;"
                    :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_AirlineCode')"
                    @parentCallBack="regionChange"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')" :required="true">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Region"
                    filterable
                    :default-value="commerceForm.name"
                    filter-type="global"
                    :filter-tag-names="['code', 'name', 'nameEnglish']"
                    :tag-name="'name'"
                    :tag-value="'name'"
                    style="width:385px;"
                    :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_ChineseName')"
                    @parentCallBack="regionChange"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')" :required="true">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Region"
                    filterable
                    :default-value="commerceForm.nameEnglish"
                    filter-type="global"
                    :filter-tag-names="['code', 'name', 'nameEnglish']"
                    :tag-name="'nameEnglish'"
                    :tag-value="'nameEnglish'"
                    style="width:385px;"
                    :placeholder="$t('CargoMsg.Cargo_PlsInput') + $t('CargoMsg.Cargo_EnglishName')"
                    @parentCallBack="regionChange"
                  />
                </el-form-item>
                <br>
                <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                  <el-input v-model="commerceForm.remark" type="textarea" :rows="4" style="width:1180px" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="section">
            <span class="title">{{ $t('CargoMsg.Cargo_AirlinePersonSetting') }}</span>
            <el-tabs v-model="activeTabName" type="card" style="width: 100%;" @tab-click="handleTabClick">
              <el-tab-pane name="tabPrePortFreightRateOfficer" :label="$t('CargoMsg.Cargo_PrePortFreightRateOfficer')">
                <tab-commerce-responsible-person ref="tabPrePortFreightRateOfficer" :title="$t('CargoMsg.Cargo_PrePortFreightRateOfficer')" :is-edit="isEdit" :type="1" :commerce="commerceForm" />
              </el-tab-pane>
              <el-tab-pane name="tabTrunkLineFreightRates" :label="$t('CargoMsg.Cargo_PersonChargeTrunkLineFreightRates')">
                <tab-commerce-responsible-person ref="tabTrunkLineFreightRates" :title="$t('CargoMsg.Cargo_PersonChargeTrunkLineFreightRates')" :is-edit="isEdit" :type="2" :commerce="commerceForm" />
              </el-tab-pane>
              <el-tab-pane name="tabLastMileFreightRates" :label="$t('CargoMsg.Cargo_PersonChargeLastMileFreightRates')">
                <tab-commerce-responsible-person ref="tabLastMileFreightRates" :title="$t('CargoMsg.Cargo_PersonChargeLastMileFreightRates')" :is-edit="isEdit" :type="3" :commerce="commerceForm" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div slot="footer">
        <span style="padding-right: 5px;">
          <!--确定/取消-->
          <el-button no="confirm" :disabled="!isEdit" type="primary" @click="save">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import tabCommerceResponsiblePerson from '@/views/cargo/v0/Information/components/basicData/tabCommerceResponsiblePerson.vue'
import { getLoading } from '@/utils/utilBaseElement'
import { saveCommerce } from '@/api/basicData/commerce'
import lodash from 'lodash'

export default {
  name: 'CommerceEditDialog',
  components: { tabCommerceResponsiblePerson, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    isEdit: { type: Boolean, required: true, default: false },
    commerce: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      url: URL,
      activeTabName: 'tabPrePortFreightRateOfficer',
      commerceForm: {
        uuid: '',
        code: '',
        name: '',
        nameEnglish: '',
        remark: '',
        commerceResponsiblePersonVos: []
      }
    }
  },
  computed: {

  },
  watch: {
    async visible(val) {
      if (val) {
        await this.onshow()
        this.activeTabName = 'tabPrePortFreightRateOfficer'
        // 确保在数据加载后执行tab的onShow
        await this.$nextTick()
        this.initTabData()
      }
      this.innerVisible = val
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.resetDialog()
      }
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    // 组件挂载后，如果对话框是可见的，初始化tab数据
    if (this.visible) {
      this.$nextTick(async() => {
        await this.onshow()
        this.initTabData()
      })
    }
  },
  methods: {
    regionChange(p) {
      if (p) {
        this.commerceForm.code = p.code
        this.commerceForm.name = p.name
        this.commerceForm.nameEnglish = p.nameEnglish
      } else {
        this.commerceForm.code = ''
        this.commerceForm.name = ''
        this.commerceForm.nameEnglish = ''
      }
    },
    // 初始化tab数据的方法
    initTabData() {
      if (this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].onShow()
      }
    },
    async onshow() {
      if (!this.commerce) {
        return
      }
      this.commerceForm = lodash.cloneDeep(this.commerce)
      // 确保数据已经准备好
      await this.$nextTick()
      console.log('commerceForm is', this.commerceForm)
    },
    save() {
      const form = this.commerceForm
      if (!form.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'))
        return
      }
      if (!form.nameEnglish) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'))
        return
      }
      if (!this.checkPersons(form)) {
        return
      }
      const loading = getLoading()
      saveCommerce(form).then(res => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.innerVisible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).catch(() => {
        this.innerVisible = false
      }).finally(() => loading.close())
    },
    checkPersons(form) {
      const persons = form.commerceResponsiblePersonVos
      if (persons && persons.length > 0) {
        const prePortFreightRateOfficers = persons.filter(person => person.type === 1)
        if (!this.checkPersonsByType(prePortFreightRateOfficers)) {
          return false
        }
        const trunkLineFreightRates = persons.filter(person => person.type === 2)
        if (!this.checkPersonsByType(trunkLineFreightRates)) {
          return false
        }
        const lastMileFreightRates = persons.filter(person => person.type === 3)
        if (!this.checkPersonsByType(lastMileFreightRates)) {
          return false
        }
      }
      return true
    },
    checkPersonsByType(persons) {
      if (persons && persons.length > 0) {
        const portEmptysUsers = []
        const samesUser = []
        for (const person of persons) {
          // 负责人名称不能为空
          if (!person.userId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NamePersonResponsible') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return false
          }
          // 港口为空的负责人
          if (!person.port) {
            portEmptysUsers.push(person.userId)
          }
          if (samesUser.includes(person.userId)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OnlyOneFullPersonSameType'))
            return false
          } else {
            samesUser.push(person.userId)
          }
        }
        // if (portEmptysUsers.length > 1) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_OnlyOneFullPerson'))
        //   return false
        // }
      }
      return true
    },
    resetDialog() {
      this.commerceForm = {
        uuid: '',
        code: '',
        name: '',
        nameEnglish: '',
        remark: '',
        commerceResponsiblePersonVos: []
      }
      this.$nextTick(() => {
        this.initTabData()
      })
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.initTabData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.details-view .commerce_content .section {
  border: 1px solid #efeeee;
  padding: 10px;
}
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.commerce_content .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.details-view .commerce_content .title {
  display: inline-block;
  position: relative;
  font-size: 13px;
  padding-left: 15px;
  line-height: 14px;
  margin-bottom: 10px;
}
.details-view .commerce_content .title:before {
  content: "";
  position: absolute;
  width: 4px;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #1f75d5;
}
</style>
